import React from 'react';

import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

function GeneralLayout() {
  return (
      <Outlet />
  );
}

export default GeneralLayout;
